import React from 'react';
import styled from 'astroturf/react';

import PremiumLock from 'js/premium/PremiumLock';
import { Icon } from 'js/design_system/Icon';

import { CtaIcon } from './autotest/AutotestFocusedNav';

type Color = 'transparent' | 'gold' | 'blue' | 'white';

type Props = {
  /**
   * Autotest CTA icon surface (AutotestFocusedNav `ctaIcon`). `'lock'` (CONTROL)
   * renders the bare `PremiumLock` exactly as today. `'crown'` (B3) replaces it
   * with a positive premium signifier (Material `workspace_premium` rosette).
   * `'pro_badge'` (B4) replaces the lock with a small gold "PRO" badge.
   */
  ctaIcon?: CtaIcon;
  circleColor?: Color;
  lockColor?: Color;
};

// `crown` signifier (B3): a gold premium rosette/crown instead of the lock.
const CrownIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--premium-gold, #877440);
`;

// `pro_badge` signifier (B4): a small gold "PRO" pill in place of the lock icon.
const ProBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1px 6px;
  border-radius: 4px;
  background: var(--premium-gold, #877440);
  color: var(--background-white, #ffffff);
  font-size: 11px;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: 0.04em;
`;

const CtaIconLock = ({ ctaIcon = 'lock', circleColor, lockColor }: Props) => {
  if (ctaIcon === 'pro_badge') {
    return <ProBadge>PRO</ProBadge>;
  }
  if (ctaIcon === 'crown') {
    return (
      <CrownIcon>
        <Icon name="workspace_premium" size={20} />
      </CrownIcon>
    );
  }
  return <PremiumLock circleColor={circleColor} lockColor={lockColor} />;
};

export default CtaIconLock;
